// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cargo-editor span[data-value='header1'], .cargo-editor h1 span {\n  font-size: 24px;\n}\n.cargo-editor span[data-value='header2'], .cargo-editor h2 span {\n  font-size: 18px;\n}\n.cargo-editor span[data-value='header3'], .cargo-editor h3 span {\n  font-size: 14.04px;\n}\n.cargo-editor span[data-value='header5'], .cargo-editor h5 span {\n  font-size: 9.96px;\n}\n", ""]);
// Exports
module.exports = exports;
